import { serializeDateField } from 'common/utils/time';
import { addMinutes } from 'date-fns';
import { DateISOString } from 'domain/Common';
import {
  EventListItemApiResponse,
  EventOwnerBase,
  EventRecording,
  EventRecordingApiResponse,
  EventRelatedVideo,
  EventTime,
  EventVideoApiResponse,
} from 'domain/event';
import { pick } from 'lodash-es';

export const mapOwnerBaseFromApi = ({
  ownerId,
  ownerName,
}: Pick<EventListItemApiResponse, 'ownerId' | 'ownerName'>): EventOwnerBase => ({
  id: ownerId,
  fullName: ownerName,
});

export const mapEventTimeFromApi = ({
  id,
  startTime,
  durationInMinutes,
}: {
  id: number;
  startTime: string;
  durationInMinutes: number;
}): EventTime => ({
  id,
  startTime,
  durationInMinutes,
  endTime: addMinutes(new Date(startTime), durationInMinutes).toISOString(),
});

export const mapEventRelatedVideoFromApi = (video: EventVideoApiResponse): EventRelatedVideo => ({
  ...pick(video, ['id', 'occurrenceOrder']),
  videoName: video.videoName,
  videoLink: video.videoLink,
  createdAt: video.createdDate,
});

// eventRecordings is a nested array, so serializeDateFields on the details response does not reach it.
export const mapEventRecordingFromApi = (recording: EventRecordingApiResponse): EventRecording => ({
  ...pick(recording, ['id', 'eventId', 'recordingLink']),
  startedAt: recording.startedAt == null ? null : (serializeDateField(recording.startedAt) as DateISOString),
});
